<mat-tab-group dynamicHeight>
    <mat-tab label="Enter">
        <form [formGroup]="scannerInput">
            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Inventory Item</mat-label>
                <input name="scanItem" matInput scanInput="ITM" formControlName="Item" (scanned)="processItemInput()">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Lot / Serial #</mat-label>
                <input name="scanItem" matInput scanInput="LOT" formControlName="LotSerNbr"
                    (scanned)="processLotNumInput()">
            </mat-form-field>
            <table class="item-info" style="width:100%;">
                <tr>
                    <td colspan="4">
                        <mat-checkbox formControlName="AutoDOCK00">Auto From DOCK00</mat-checkbox>
                    </td>
                </tr>
                <tr>
                    <td class="label">Inventory ID:</td>
                    <td class="value">{{item?.InventoryID}}</td>
                    <td class="label">Dflt Loc:</td>
                    <td class="value">{{item?.DefaultIssueFrom}}</td>
                </tr>
            </table>
        </form>

        <table mat-table [dataSource]="pendingTransfers" class="transfer-table">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let item">{{item.InventoryID}}</td>
            </ng-container>
            <ng-container matColumnDef="LotSerNbr">
                <th mat-header-cell *matHeaderCellDef>Lot/Ser Nbr</th>
                <td mat-cell *matCellDef="let item">{{item.LotSerialNbr}}</td>
            </ng-container>
            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let item">{{item.Qty}} {{item.UOM}}</td>
            </ng-container>
            <ng-container matColumnDef="FromLocationID">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let item">{{item.FromLocationID}}</td>
            </ng-container>
            <ng-container matColumnDef="Menu">
                <th mat-header-cell *matHeaderCellDef class="menu-column"></th>
                <td mat-cell *matCellDef="let item" class="menu-column">
                    <button mat-icon-button [matMenuTriggerFor]="pendingTransferMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #pendingTransferMenu="matMenu">
                        <a mat-menu-item (click)="cancelPendingTransfer(item)">
                            <mat-icon>cancel</mat-icon>
                            <span>Cancel</span>
                        </a>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="pendingTransfersColumns"></tr>
            <tr mat-row *matRowDef="let item; columns: pendingTransfersColumns"></tr>
        </table>
    </mat-tab>
    <mat-tab label="Review">
        <div style="text-align:right; padding: 10px 1em;">
            <button mat-raised-button color="primary" [disabled]="transfer.Details.length == 0"
                [disabled]="_pieceSelectCount > 0" (click)="releaseTransfer()">Release
                Transfer</button>
        </div>
        <table mat-table [dataSource]="transfer.Details" class="transfer-table">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let item">{{item.InventoryID}}</td>
            </ng-container>
            <ng-container matColumnDef="LotSerNbr">
                <th mat-header-cell *matHeaderCellDef>Lot/Ser Nbr</th>
                <td mat-cell *matCellDef="let item">{{item.LotSerialNbr}}</td>
            </ng-container>
            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let item">{{item.Qty}} {{item.UOM}}</td>
            </ng-container>
            <ng-container matColumnDef="FromLocationID">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let item">{{item.FromLocationID}}</td>
            </ng-container>
            <ng-container matColumnDef="ToLocationID">
                <th mat-header-cell *matHeaderCellDef>To</th>
                <td mat-cell *matCellDef="let item">{{item.ToLocationID}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="documentDetailsColumns"></tr>
            <tr mat-row *matRowDef="let item; columns: documentDetailsColumns"></tr>
        </table>
    </mat-tab>
</mat-tab-group>

<ng-template #transferSetupDialog let-data>
    <div id="transferSetupDialog">
        <mat-dialog-content>
            Warehouse: <mayer-warehouse-selector name="warehouseID" [formControl]="warehouseID">
            </mayer-warehouse-selector>
        </mat-dialog-content>

        <mat-dialog-actions style="justify-content: space-between;">
            <button matSuffix mat-raised-button mat-dialog-close style="justify-content: flex-end;">Cancel</button>
            <button matSuffix mat-raised-button color="primary" [mat-dialog-close]="true"
                style="justify-content: flex-end;">OK</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-template #selectSourceLocation let-data>
    <h3 mat-dialog-title>Multiple Sources Found</h3>
    <mat-dialog-content>
        <table><tr>
            <td><item-thumbnail [item]="item!" [size]="50"></item-thumbnail></td>
            <td>{{item!.InventoryID}}<br />{{item!.Description}}</td>
        </tr></table>
        <hr />
        <table>
            <!-- <thead>
                <tr>
                    <td style="border-bottom: thin solid;">Location</td>
                    <td style="border-bottom: thin solid;" *ngIf="item!.isLotSerItem">Lot/Ser #</td>
                    <td style="border-bottom: thin solid;">Qty</td>
                </tr>
            </thead> -->
            <tbody>
                <tr *ngFor="let piece of data.pieces">
                    <td><button color="accent" mat-raised-button matSuffix
                        style="width:100%;"
                        (click)="data.receiveSourceLocation(piece.LocationID)">{{piece.LocationID}}</button></td>
                    <td *ngIf="item!.isLotSerItem">{{piece.LotSerialNbr}}</td>
                    <td>{{piece.QtyOnHand}} {{piece.BaseUOM}}</td>
                </tr>
            </tbody>
        </table>
        <form>
            <mat-form-field appearance="fill">
                <mat-label>From Location:</mat-label>
                <input matInput type="text" [formControl]="selectPieceFromLocation" scanInput="BIN"
                    (scanned)="data.receiveSourceLocation($event)">
            </mat-form-field>
            <mat-error *ngIf="data.errorMessage">{{data.errorMessage}}</mat-error>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button mat-dialog-close matSuffix>Cancel</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #getTransferQuantity let-data>
    <h3 mat-dialog-title>Transfer Quantity</h3>
    <mat-dialog-content>
        <!-- <mat-form-field>
            <mat-label>Location:</mat-label>
            <input matInput [disabled]="true" [value]="data.piece.LocationID">
        </mat-form-field> -->
        <div>
            <label>Location: </label>
            <span>{{data.piece.LocationID}}</span>
        </div>
        <div>
            <label>On Hand: </label>
            <span>{{data.piece.QtyOnHand}} {{data.piece.BaseUOM}}</span>
        </div>
        <mat-form-field appearance="fill">
            <mat-label>Quantity</mat-label>
            <input matInput type="number" [formControl]="transferQuantity" inputmode="numeric"
                (keyup.enter)="data.enterKeyHandler()">
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button mat-dialog-close="max-quantity" matSuffix
            color="accent">{{data.piece.QtyOnHand}}</button>
        <button mat-raised-button mat-dialog-close matSuffix>Cancel</button>
        <button mat-raised-button [mat-dialog-close]="true" matSuffix color="primary">OK</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #changePrimaryBin let-data>
    <h3 mat-dialog-title>Change Primary Bin</h3>
    <mat-dialog-content>
        <fieldset>
        <mat-form-field>
            <mat-label>Inventory ID:</mat-label>
            <input matInput [formControl]="rehomeInventoryID" scanInput="ITM" (blur)="UpdateRehomeItem()">
        </mat-form-field>
        <div>
            <label>Current Primary Bin:</label>
            <span style="padding-left:1em;">{{rehomeItemCurrentBin}}</span>
        </div>
        <mat-form-field appearance="fill">
            <mat-label>New Primary Bin:</mat-label>
            <input matInput [formControl]="rehomeLocationID">
        </mat-form-field>
    </fieldset>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button mat-dialog-close matSuffix>Cancel</button>
        <button mat-raised-button [mat-dialog-close]="true" matSuffix color="primary"
            [disabled]="!locations.contains(rehomeLocationID.value)">OK</button>
    </mat-dialog-actions>
</ng-template>